var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { CardElement } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { PaymentEndpoints } from "../endpoints/payment.endpoints";
var getStripeApiKey = function () {
    switch (window.location.hostname) {
        case 'turn2me.ie':
        case 'wp.turn2me.ie':
            return 'pk_live_51GcuOmKDEmPif3VtH1Xe6ZVpsIvIBbVv1FsCCkk09EpAOwVj6ZyhH9Re0we38uG2rqjeqpiLPO7HCvHaG9kPefs600mEGIZsQE';
        default:
            return 'pk_test_51Jwl6GGv7VC4NkBPpHy4K92fWETdKanED80foU8MY2Yrj59w11wSQ2gUzbbOuRocMPfPcdsNJV3w6UqArWHRcmcR00ghTyHjQO';
        // return 'pk_test_80o5DUnEogasKoB4ufzAxGrx00H9fiQ3TQ';
    }
};
export var initStripe = new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
    var key, errorMessage, _a, e_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                key = getStripeApiKey();
                if (!key) {
                    errorMessage = 'A valid API Key is not provided for Stripe, payment related components will not function.';
                    if (process.env.NODE_ENV === 'development') {
                        console.warn(errorMessage);
                    }
                    else
                        reject(errorMessage);
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                _a = resolve;
                return [4 /*yield*/, loadStripe(key)];
            case 2:
                _a.apply(void 0, [_b.sent()]);
                return [3 /*break*/, 4];
            case 3:
                e_1 = _b.sent();
                // FIXME: remove this try catch when stripe is implemented
                console.warn(e_1);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); });
export var getSetupIntent = function (API) { return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                url = PaymentEndpoints.getIntent();
                return [4 /*yield*/, API.get(url)];
            case 1:
                response = _a.sent();
                resolve(response.data);
                return [3 /*break*/, 3];
            case 2:
                e_2 = _a.sent();
                reject(e_2);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }); };
export var getSetupIntentSecret = function (API) { return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
    var intent, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getSetupIntent(API)];
            case 1:
                intent = _a.sent();
                resolve(intent.client_secret);
                return [3 /*break*/, 3];
            case 2:
                e_3 = _a.sent();
                reject(e_3);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }); };
export var getPaymentMethodIdFromStripe = function (API, stripe, elements, cardHolderName) { return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
    var cardElement, intentSecret, e_4, confirmCardSetupResult, e_5, setupIntent, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!stripe || !elements) {
                    reject(new Error('Stripe is not initiated'));
                    return [2 /*return*/];
                }
                cardElement = elements.getElement(CardElement);
                if (!cardElement) {
                    reject(new Error('no cardElement mounted'));
                    return [2 /*return*/];
                }
                intentSecret = null;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, getSetupIntentSecret(API)];
            case 2:
                intentSecret = _a.sent();
                return [3 /*break*/, 4];
            case 3:
                e_4 = _a.sent();
                reject(e_4);
                return [2 /*return*/];
            case 4:
                if (!intentSecret) {
                    reject(new Error('Failed to get intent secret...'));
                    return [2 /*return*/];
                }
                confirmCardSetupResult = {};
                _a.label = 5;
            case 5:
                _a.trys.push([5, 7, , 8]);
                return [4 /*yield*/, stripe.confirmCardSetup(intentSecret, {
                        payment_method: {
                            card: cardElement,
                            billing_details: {
                                name: cardHolderName
                            }
                        }
                    })];
            case 6:
                confirmCardSetupResult = _a.sent();
                return [3 /*break*/, 8];
            case 7:
                e_5 = _a.sent();
                reject(e_5);
                return [2 /*return*/];
            case 8:
                setupIntent = confirmCardSetupResult.setupIntent, error = confirmCardSetupResult.error;
                if (!(setupIntent === null || setupIntent === void 0 ? void 0 : setupIntent.payment_method)) {
                    reject(error);
                    return [2 /*return*/];
                }
                resolve(setupIntent.payment_method);
                return [2 /*return*/];
        }
    });
}); }); };
export var createPaymentMethod = function (API, stripe, elements, cardHolderName) { return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
    var paymentMethodId, url, payload, response, e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, getPaymentMethodIdFromStripe(API, stripe, elements, cardHolderName)];
            case 1:
                paymentMethodId = _a.sent();
                url = PaymentEndpoints.createPaymentMethod();
                payload = {
                    'paymentMethod': paymentMethodId,
                    'isDefault': true,
                };
                return [4 /*yield*/, API.postRaw(url, payload)];
            case 2:
                response = _a.sent();
                resolve(__assign({ paymentMethodId: paymentMethodId }, response.data));
                return [3 /*break*/, 4];
            case 3:
                e_6 = _a.sent();
                reject(e_6);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }); };
